import { getThunkAndSlice } from "@src/store/getThunkAndSlice";
import { RootState } from "../store";
import { pricingActions } from "..";
import { EventInventoryRecord, getInventoryCacheEventId } from "@src/store/pricing/queryEventInventoryAllSlice";

const initialState = false;
export interface IAppendListingNotes {
	listingIds: Array<number>;
	internalNotes: string | null;
	externalNotes: string | null;
}
export const { thunk: appendListingNotes, slice: appendListingNotesSlice } = getThunkAndSlice<
	IAppendListingNotes,
	typeof initialState
>({
	initialState,
	path: "/api/Pricing/UpdateListingNotes",
	method: "post",
	onAfterRequest: async (data, params, state, dispatch) => {
		const rootState = state as RootState;
		const eventId = getInventoryCacheEventId(rootState);
		const inventoryAllState = rootState.pricing.eventInventoryAll.data;

		const newData = inventoryAllState.map((x) => {
			return params.listingIds.includes(x.Listing_ID) ? { ...x, External_Notes: params.externalNotes ?? "" } : x;
		});

		dispatch(pricingActions.updateInventoryAll({ data: newData, eventId }));

		if (rootState.pricing.globalInventory.data.length) {
			const newGlobalData = (rootState.pricing.globalInventory.data as Array<EventInventoryRecord>).map((x) => {
				return params.listingIds.includes(x.Listing_ID) ? { ...x, External_Notes: params.externalNotes ?? "" } : x;
			});
			dispatch(pricingActions.updateGlobalInventory({ data: newGlobalData }));
		}

		return data;
	},
});
